import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új szoba',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "companyId",
                label: "Cég azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "siteId",
                label: "Telephely azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "typeId",
                label: "Szoba típus",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getRoomTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true,
                formRequired: true
            },
            {
                name: "type.text",
                label: "Szoba típus",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "basicTreatmentTypeId",
                label: "basicTreatmentTypeId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        bedFormIsOpen: false,
        bedGridIsOpen: true,
        bedActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Ágy',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newBedRow'
            }
        ],
        bedFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToBedGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetBedForm'
            }
        ],
        bedRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyBedRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteBedRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteBedRow'
            }
        ],
        bedHeaderFields: [
            {
                name: "id",
                label: "id",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 6,
                formVisible: true
            },
            {
                name: "roomId",
                label: "roomId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "companyId",
                label: "companyId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "siteId",
                label: "siteId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
